import { from } from 'rxjs';

import { fetchSuppliesProducts } from '../../pages/supplies-page/api/fetch-products';

export const getSuppliesProducts = () => {
  const request = fetchSuppliesProducts();
  return from(request);
};
